<template>
  <div id="app">
    <!-- 背景音乐元素 -->
    <audio ref="bgAudio" :src="musicSrc" loop preload="metadata" />
    
    <!-- 右上角音乐播放按钮 -->
    <div class="music-btn" @click="toggleMusic">
      <img v-if="isPlaying" :src="playIcon" alt="播放音乐" class="music-icon playing">
      <img v-else :src="pauseIcon" alt="暂停音乐" class="music-icon">
    </div>
    <!-- 加载页面 -->
    <div v-if="loading_num < 100" class="loading_box">
      <div class="loading_prcess_box">
        <div class="loading_precess">
          <div :style="`width:${loading_num}%`" class="loading_precess_bar"></div>
        </div>
        <div   class="loading_text">{{loading_num}}%</div>
      </div>
      <div class="support_text">
        <p>
          出品人：刘建光<br>
          统筹：谭登<br>
          执行：印奕帆<br>
          编辑：欧小雷 潘华<br>
          设计/AIGC/后期：胡艳丽<br>
          交互：罗江 郭诚
        </p>
        <h1>
          湖南日报社出品<br>
          华声在线制作
        </h1>
      </div>
      <div @click="loading_num >= 100 ? show_route = true : null" class="enter_btn">
          <img v-if="false" src="@/assets/enter.png" alt="" srcset="">
        </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import $ from 'jquery'

// 加载相关
const loading_num = ref(0)
const show_route = ref(false)
const context = require.context('./assets', true, /\.(png|jpe?g|gif)$/)
const promises = []
context.keys().forEach((element,i) => {
  let import_str = element.replace('./', '')
  promises.push(import('./assets/'+import_str))
})
let image_num = 0
Promise.all(promises).then((res) => {
  res.forEach((element,i) => {
      let img = new Image();
      img.src = element.default;
      img.onload = function() {
        image_num++
        loading_num.value = parseInt((image_num/(promises.length))*100)
      };
      img.onerror = function() {
        image_num++
        loading_num.value = parseInt((image_num/promises.length)*100)
      };
    })
})
// 音乐相关
const bgAudio = ref(null)
const isPlaying = ref(false)
const musicSrc = require('@/assets/audio/bgmusic.mp3') // MP3音乐文件路径
const playIcon = require('@/assets/audio/music-play.png') // 播放图标（使用现有图片）
const pauseIcon = require('@/assets/audio/music-pause.png')// 暂停图标（使用现有图片）
const route = useRoute()
const showMusicBtn = computed(() => route.path === '/nav' || route.path === '/treasure')

// 切换音乐播放状态
const toggleMusic = async () => {
  try {
    if (isPlaying.value) {
      bgAudio.value.pause()
      isPlaying.value = false
    } else {
      await bgAudio.value.play()
      isPlaying.value = true
    }
  } catch (error) {
    console.error('音乐播放失败:', error)
  }
}

// 播放音乐的方法
const playMusic = async () => {
  try {
    if (bgAudio.value && isPlaying.value === false) {
      await bgAudio.value.play()
      isPlaying.value = true
    }
  } catch (error) {
    console.error('音乐播放失败:', error)
  }
}
window.onLoad = function() {
  let post_data = {
  "share_title": "H5｜出发！湖南“十五五”时光体验官",
  "share_des": "循着“十五五”宏伟蓝图，解锁你日常里的未来彩蛋。",
  "share_img": 'https://img2.voc.com.cn/9/2026/02/02/61f71000018de49851383ba2a33d024eb7c8f83c1770022198330.jpeg?pid=36836594',
  "share_url": location.href,
  "poster_img": 'https://img2.voc.com.cn/9/2026/02/02/61f71000018de49851383ba2a33d024eb7c8f83c1770022198330.jpeg?pid=36836594'
}
  vmobile.setShare(JSON.stringify(post_data))
}
// 页面加载后初始化
onMounted(() => {
  // 仅初始化，不自动播放音乐
  // 音乐将在用户点击按钮时播放
  
  // 将播放音乐的方法挂载到全局，以便其他组件调用
  window.playBgMusic = playMusic
  //微信分享
var shareTitle = 'H5｜出发！湖南“十五五”时光体验官';
var shareUrl = window.location.href;
var shareDesc = "循着“十五五”宏伟蓝图，解锁你日常里的未来彩蛋。";
var shareImg = 'https://img2.voc.com.cn/9/2026/02/02/61f71000018de49851383ba2a33d024eb7c8f83c1770022198330.jpeg?pid=36836594';

$.ajax({
  url:"https://cgi.voc.com.cn/api/weixin/xhn.php?url=" + encodeURIComponent(shareUrl),
  dataType: "json",
  success: function (data) {
    $.each(data, function (index, result) {
      if (result["status"] == 1) {
        var appId = result["appId"],
          timestamp = result["timestamp"],
          nonceStr = result["nonceStr"],
          signature = result["signature"];
        wx.config({
          debug: false,
          appId: appId,
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "updateAppMessageShareData",
            "updateTimelineShareData",
          ],
          openTagList: ["wx-open-launch-app"],
        });
        wx.ready(function () {
          wx.updateAppMessageShareData({
              title: shareTitle,
              desc: shareDesc,
              link: shareUrl,
              imgUrl: shareImg,
          });
          wx.updateTimelineShareData({
              title: shareTitle,
              link: shareDesc,
              imgUrl: shareImg,
          });
          wx.onMenuShareTimeline({
              title: shareTitle,
              desc: shareDesc,
              link: shareUrl,
              imgUrl: shareImg,
          });
          wx.onMenuShareWeibo({
              title: shareTitle,
              desc: shareDesc,
              link: shareUrl,
              imgUrl: shareImg,
          });
        });
        wx.error(function (res) {});
      }
    });
  },
});
})

// 将 playMusic 方法暴露给全局，以便其他组件调用
defineExpose({
  playMusic
})

 
</script>

<style lang="scss">
html,body{
  font-size: 10vw;
  overflow-x: hidden;
  @media screen and (min-width: 1024px){
        max-width: 677px !important;
        margin: auto !important;
        font-size: 67px;
    }
}
.loading_box{
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 10;
  background: linear-gradient(-135deg, rgb(253,217,173),rgb(222,66,36));
  padding: 416px 0 113px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media screen and (min-width: 1024px){
        max-width: 677px !important;
        margin: auto !important;
        left: 50%;
        transform: translateX(-50%);
        padding-top: 200px;
    }
  .enter_btn{
    width: 250px;
    height: 76px;
    img{
      width: 100%;
    }
  }
  .loading_prcess_box{
    width: 440px;
    .loading_text{
      color: #fdd9ac;
      font-size: 36px;
    }
    .loading_precess{
      width: 100%;
      height: 10px;
      background-color: #fdd9ac;
      border-radius: 5px;
      margin-bottom: 40px;
      .loading_precess_bar{
        width: 10%;
        height: 10px;
        background-color: #df4727;
	      border-radius: 5px;
      }
    }
  }
  .support_text{
    font-size: 36px;
    color: #fff0d3;
    h1{
      margin-top: 30px;
      font-size: 36px;
    }
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
*{
  margin: 0;
  padding: 0;
}

.music-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 2147483647;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    background: rgba(255, 255, 255, 0.3);
  }
}

.music-icon {
  width: 70%;
  height: 70%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.music-icon.playing {
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
